import { render, staticRenderFns } from "./CompanyBusiness.vue?vue&type=template&id=289e77ce&scoped=true&"
import script from "./CompanyBusiness.vue?vue&type=script&lang=js&"
export * from "./CompanyBusiness.vue?vue&type=script&lang=js&"
import style0 from "./CompanyBusiness.vue?vue&type=style&index=0&id=289e77ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289e77ce",
  null
  
)

export default component.exports